import { useProject } from "@/core/api/queries";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function useCheckIfProjectExists(projectId: string) {
  const companyProject = useProject(projectId)
  const navigate = useNavigate();

  useEffect(() => {
    if (companyProject.isLoading || !companyProject.isFetched) {
      return;
    }

    if (!companyProject.data) {
      navigate("/app/onboarding");
    }
  }, [companyProject.isLoading, companyProject.data, navigate]);
}
